import { isHttpClientError } from 'core/infra/http/HttpClient'

export const INCORRECT_CREDENTIALS_DETAIL = 'Incorrect authentication credentials.'

export function isIncorrectCredentialsError(error: unknown): boolean {
  if (!isHttpClientError(error)) {
    return false
  }

  if (error.response?.status !== 401) {
    return false
  }

  const data = error.response.data as { detail?: string } | undefined

  return data?.detail === INCORRECT_CREDENTIALS_DETAIL
}
